export default __webpack_public_path__ + "static/media/7693329_vk_social media_logo_icon.0851b416.svg";